<template>
  <div>
    <div class="action-buttons">
      <div class="left-buttons">
        <div class="form-group mar-rt-10" style="max-width: 230px;">
          <label>{{ $t('gestiune.locatie') }}</label>
          <select class="form-control" v-model="selectedVatNumber">
            <option :value="null">Selectează</option>
            <option
              v-for="group in groupedLocations"
              :key="group.vat"
              :value="group.vat"
            >
              VAT: {{ group.vat }} — {{ group.locations.map(l => l.name).join(', ') }}
            </option>
          </select>
        </div>
        <div class="form-group mar-rt-10">
            <label>{{ $t('gestiune.type') }}</label>
            <select v-model="selectedCategory" class="form-control">
              <option value="">Selectează</option>
              <option
                v-for="(cat, index) in categories"
                :key="index"
                :value="cat.value"
              >
                {{ cat.label }}
              </option>
            </select>
        </div>

        <div class="form-group">
          <label>{{ $t('gestiune.productName') }}</label>
          <input v-model="productNameFilter" type="text" ref="searchTerm" class="form-control" placeholder="Caută produs...">
          <div class="v-select-loader" v-if="loadingProducts"></div>
        </div>

        <div class="search-button-reports">
          <button
              :title="$t('reports.search')"
              class="btn add mar-rt-10"
              @click="getProducts(1, pageSize)"
          >
              <i class="ti-search"></i>
              <span>{{ $t('general.search') }}</span>
          </button>
        </div>
      </div>
      <div class="right-buttons">
          <button class="btn add mar-rt-10"  @click.prevent="openAddProductModal" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/add.png">
            {{ $t('gestiune.addProduct') }}
          </button>
      </div>
    </div>
    <div class="card mar-to-15">
      <div class="card-content">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <div class="data-table">
            <el-table :data="filteredProducts" :empty-text="$t('gestiune.noData')">
                <el-table-column prop="product" :label="$t('gestiune.product')"></el-table-column>
                <el-table-column prop="codeProduct" :label="$t('gestiune.codeProduct')"></el-table-column>
                <el-table-column prop="categorie" :label="$t('gestiune.type')">
                  <template slot-scope="scope">
                    <span>
                      <template v-if="scope.row.categorie && scope.row.categorie.includes('Reteta')">
                        <span
                          class="categorie-label"
                          :class="getCategoryClass(scope.row.categorie)"
                        >
                          {{ scope.row.categorie.replace(' (Reteta)', '') }}
                        </span>
                        <span
                          class="reteta-label"
                          :style="scope.row.hasReteta ? 'background-color: green; color: white;' : 'background-color: red; color: white;'"
                          title="Rețetă"
                        >
                          {{ scope.row.hasReteta ? 'R' : '!' }}
                        </span>
                      </template>

                      <template v-else-if="scope.row.categorie">
                        <span
                          class="categorie-label"
                          :class="getCategoryClass(scope.row.categorie)"
                        >
                          {{ scope.row.categorie }}
                        </span>
                      </template>

                      <template v-else>
                        <span class="categorie-label unallocated">Tip nealocat</span>
                      </template>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="um" :label="$t('gestiune.um')"></el-table-column>
                <el-table-column prop="stocMinim" :label="$t('gestiune.stocMinim')">
                  <template slot-scope="scope">
                    {{ scope.row.stocMinim || 0 }}
                  </template>
                </el-table-column>
                <el-table-column prop="validity" :label="$t('gestiune.validity')">
                  <template slot-scope="scope">
                    {{ scope.row.validity && scope.row.validity.value != null && scope.row.validity.unit
                      ? scope.row.validity.value + ' ' + scope.row.validity.unit
                      : '' }}
                  </template>
                </el-table-column>
                <el-table-column prop="price" :label="$t('gestiune.price')">
                  <template slot-scope="scope">
                    {{ scope.row.price || '' }}
                  </template>
                </el-table-column>
                <el-table-column prop="currency" :label="$t('gestiune.currency')"></el-table-column>
                <el-table-column :label="$t('general.actions')" width="100">
                  <template slot-scope="scope">
                    <el-dropdown trigger="click" placement="bottom-end">
                      <!-- Trigger: săgeată jos cu border violet -->
                      <span class="arrow-box">
                        &#9662;
                      </span>
                      <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                        <el-dropdown-item @click.native="editProduct(scope.row.id, scope.row.vatNumber)">
                          {{ $t('general.edit') }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-table-column>

            </el-table>
            <el-pagination
              :key="paginationKey"
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change="handlePageChange"
              style="margin-top: 15px; text-align: right;"
            ></el-pagination>
        </div>
      </div>
    </div>
   <vmodal name="addProductModal" height="auto" width="1200" class="addProductModal">
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <p>{{ $t('gestiune.addProduct') }}</p>
          </div>
          <div class="modal-body">
            <div class="row mt-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.locatie') }}</label>
                  <select class="form-control" v-model="selectedLocationId" v-validate="modelValidate.selectedLocationId">
                    <option value="" disabled>Selectează locația*</option>
                    <optgroup
                      v-for="group in groupedLocations"
                      :key="group.vat"
                      :label="`VAT: ${group.vat}`"
                    >
                      <option
                        v-for="loc in group.locations"
                        :key="loc.true_id"
                        :value="loc.true_id"
                      >
                        {{ loc.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.productName') }}*</label>
                  <input type="text" :placeholder="$t('gestiune.productName')" v-model="productName" v-validate="modelValidate.productName" class="form-control"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.codeProduct') }}*</label>
                  <input type="text" :placeholder="$t('gestiune.codeProduct')" v-model="codeProduct" v-validate="modelValidate.codeProduct" class="form-control"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.productDescription') }}</label>
                  <input type="text" :placeholder="$t('gestiune.productDescription')" v-model="productDescription"  class="form-control"/>
                </div>
              </div>
              <div class="col-md-6">
                  <div class="form-group">
                      <label>{{ $t('gestiune.type') }}*</label>
                      <select
                        v-model="productType"
                        v-validate="modelValidate.productType"
                        class="form-control"
                      >
                        <option value="" disabled>Selectează opțiunea</option>
                        <option
                          v-for="(type, index) in productTypes"
                          :key="index"
                          :value="type.value"
                        >
                          {{ type.label }}
                        </option>
                      </select>
                  </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.um') }} *</label>
                  <select v-model="um" class="form-control" v-validate="modelValidate.um">
                    <option value="" disabled>Selectează unitatea de măsură</option>
                    <template v-for="unit in mesurementsUnits">
                      <option :value="unit.short">{{unit.short}}</option>
                    </template>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.currency') }} *</label>
                  <select v-model="currency" class="form-control">
                      <option value="RON">RON</option>
                      <option value="EUR">EURO</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.tva') }} *</label>
                  <select v-model="cotaTva" class="form-control" v-validate="modelValidate.cotaTva">
                    <option disabled value="">Selectează TVA</option>
                    <option
                      v-for="vat in vats"
                      :key="vat.tax_id"
                      :label="`${vat.amount} %`"
                      :value="vat.amount"
                    />
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.stocMinim') }}</label>
                  <input type="text" :placeholder="$t('gestiune.stocMinim')" v-model="stocMinim" class="form-control"/>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="button-group">
              <a @click="closeModal" class="btn btn-danger btn-icon mar-rt-10 delete">{{ $t('general.cancel2') }}</a>
              <button @click.prevent="validate" class="btn btn-icon btn-success mar-rt-10 save">{{ $t('general.save') }}</button>
            </div>
          </div>
        </div>
      </div>
   </vmodal>
  </div>
</template>

<script>
  import swal from 'sweetalert2'
  export default {
    data () {
      return {
        loading: false,
        loadingProducts: false,
        loadingTimeout: null,
        onSeriesInputTimeout: null,
        searchTimeout: null,
        paginationKey: 0,
        totalItems: 0,
        currentPage: 1,
        pageSize: 20,
        selectedVatNumber: null,
        selectedLocationId: '',
        selectedLocation: null,
        vatNumber: null,
        vats: [],
        locations: [],
        tableData: [],
        searchResults: [],
        productName: '',
        productDescription: '',
        productNameFilter: '',
        stocMinim: null,
        cotaTva: '',
        productType: '',
        productTypes: [
          { value: 'Marfa', label: 'Marfa' },
          { value: 'Materii prime', label: 'Materii prime' },
          { value: 'Materiale consumabile', label: 'Materiale consumabile' },
          { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' },
          { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' },
          { value: 'Produs rezidual', label: 'Produs rezidual' },
          { value: 'Ambalaje', label: 'Ambalaje' },
          { value: 'Obiecte de inventar', label: 'Obiecte de inventar' }
        ],
        um: '',
        // price: '',
        currency: 'RON',
        codeProduct: '',
        selectedCategory: '',
        categories: [
          { value: 'Marfa', label: 'Marfa' },
          { value: 'Materii prime', label: 'Materii prime' },
          { value: 'Materiale consumabile', label: 'Materiale consumabile' },
          { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' },
          { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' },
          { value: 'Produs rezidual', label: 'Produs rezidual' },
          { value: 'Ambalaje', label: 'Ambalaje' },
          { value: 'Obiecte de inventar', label: 'Obiecte de inventar' },
          { value: 'fara_categorie', label: 'Fara categorie' }
        ],
        mesurementsUnits: [],
        modelValidate: {
          productName: { required: true },
          productType: { required: true },
          price: { required: true },
          codeProduct: { required: true },
          um: { required: true },
          cotaTva: { required: true },
          selectedLocationId: { required: true }
        }
      }
    },
    props: {
      groupedLocations: {
        type: Array,
        required: true
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')
      this.loadMesurementsUnits()

      const query = this.$route.query
      console.log('Query params on created:', query)
      const queryVatNumber = query.vatNumber
      const queryLocationId = query.locationId

      if (queryVatNumber || queryLocationId) {
        // Dacă există în query, setăm valorile
        if (queryLocationId) {
          this.selectedLocationId = queryLocationId
        }
        if (queryVatNumber) {
          this.selectedVatNumber = queryVatNumber
        }
      } else if (this.groupedLocations && this.groupedLocations.length === 1) {
        const onlyGroup = this.groupedLocations[0]

        // Setăm automat prima locație din grup
        if (onlyGroup.locations && onlyGroup.locations.length > 0) {
          this.selectedLocationId = onlyGroup.locations[0].true_id
        }

        // Setăm automat VAT-ul grupului
        this.selectedVatNumber = onlyGroup.vat
      }

      this.$bus.$on('refresh', this.handleRefresh)
    },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    watch: {
      productNameFilter () {
        clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(async () => {
          this.$refs.searchTerm.focus()
        }, 300)
      },
      selectedLocationId (id) {
        if (!id) return

        for (const group of this.groupedLocations) {
          const loc = group.locations.find(l => l.true_id === id)
          if (loc) {
            this.selectedLocation = loc
            this.loadVats(loc.true_id)

            break
          }
        }
      },
      selectedVatNumber (newVat) {
        this.selectedVatNumber = newVat

        if (!newVat) {
          this.tableData = []
          this.totalItems = 0
          this.currentPage = 1
        }
      },
      productType (newVal) {
        if (newVal === 'Semifabricate (Reteta)') {
          this.um = 'BUC'
        }
      }
    },
    computed: {
      filteredProducts () {
        return this.tableData
        // if (!this.productNameFilter) return this.tableData

        // return this.tableData.filter(product => {
        //   return (product.product || '').toLowerCase().includes(this.productNameFilter.toLowerCase())
        // })
      }
    },
    methods: {
      handleRefresh () {
        this.handlePageChange(this.currentPage)
      },
      async loadMesurementsUnits () {
        this.mesurementsUnits = await this.getMesurementsUnits()
      },
      async loadVats (locationId) {
        this.vats = await this.fetchVats(locationId)
      },
      handlePageChange (page) {
        this.currentPage = page
        this.getProducts(this.currentPage, this.pageSize)
      },
      getCategoryClass (categorie) {
        if (!categorie) return ''
        const name = categorie.replace(' (Reteta)', '').trim().toLowerCase()
        return name.replace(/\s+/g, '-')
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveProduct() }
        })
      },
      addBonProduct () {
        this.$router.push('/management/bon-product/add')
      },
      editProduct (id, vatNumber) {
        this.$router.push(`/management/nomenclator-products/edit/${id}/${vatNumber}`)
      },
      async saveProduct () {
        const missingFields = []

        if (!this.selectedLocation) missingFields.push('Trebuie să selectați o locație')
        if (!this.productName) missingFields.push('Numele produsului este obligatoriu')
        if (!this.codeProduct) missingFields.push('Codul produsului este obligatoriu')
        if (this.cotaTva === null || this.cotaTva === undefined || this.cotaTva === '') {
          missingFields.push('Cota TVA este obligatorie')
        }
        if (!this.currency) missingFields.push('Moneda este obligatorie')
        if (!this.um) missingFields.push('Unitatea de măsură (UM) este obligatorie')
        if (!this.productType) missingFields.push('Categoria produsului este obligatorie')

        if (missingFields.length > 0) {
          swal({
            title: 'Câmpuri lipsă',
            html: missingFields.map(f => `• ${f}`).join('<br>'),
            icon: 'warning',
            showConfirmButton: true,
            allowOutsideClick: false
          })
          return
        }

        const productData = {
          name: this.productName,
          product_code: this.codeProduct,
          // price: parseFloat(this.price),
          is_with_vat: true,
          vat_percent: parseInt(this.cotaTva),
          currency: this.currency,
          um: this.um,
          externalId: '',
          externalCompanyId: this.companyID,
          externalLocationId: this.selectedLocation.true_id,
          vatNumber: this.selectedLocation.inv_fiscal_code,
          categorie: this.productType,
          stocMinim: this.stocMinim,
          is_external: 0,
          pret_vanzare: []
        }

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/nomenclator`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(productData)
          })

          const data = await response.json()
          console.log('Product saved successfully:', data)

          if (!response.ok) {
            swal({
              title: 'Eroare',
              text: data.details || 'A apărut o eroare la salvarea produsului.',
              type: 'error',
              timer: 4000,
              showConfirmButton: false
            })
            return
          }

          swal({
            title: 'Succes',
            text: 'Produsul a fost salvat cu succes.',
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          })

          this.$modal.hide('addProductModal')
          this.selectedVatNumber = this.selectedLocation.inv_fiscal_code
          await this.getProducts()

          // Resetăm câmpurile
          this.resetFields()
        } catch (error) {
          console.error('Error saving product:', error)
          swal({
            title: 'Eroare',
            text: 'A apărut o eroare la salvarea produsului.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      },
      async getProducts (page = 1, pageSize = this.pageSize) {
        this.tableData = []
        this.totalItems = 0

        if (!this.companyID) {
          console.error('Missing companyID')
          return
        }

        // if (!this.selectedVatNumber) {
        //   swal({
        //     title: 'Locație neselectată',
        //     text: 'Trebuie să selectați o locație pentru a vedea produsele.',
        //     type: 'warning',
        //     timer: 2500,
        //     showConfirmButton: false
        //   })
        //   return
        // }

        clearTimeout(this.loadingTimeout)
        this.loadingTimeout = setTimeout(() => {
          this.loading = true
        }, 300)

        this.loadingProducts = true
        try {
          const categoryParam = this.selectedCategory
            ? `&categorie=${encodeURIComponent(this.selectedCategory)}&is_search=true`
            : ''

          // Inițializează URL-ul de bază
          let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/products?externalCompanyId=${this.companyID}${categoryParam}`

          if (this.selectedVatNumber) {
            url += `&vatNumber=${encodeURIComponent(this.selectedVatNumber)}`
          }
          if (this.productNameFilter) {
            url += `&name=${encodeURIComponent(this.productNameFilter)}`
          }

          url += `&page=${page}&limit=${pageSize}`

          const response = await fetch(url)

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }

          const data = await response.json()
          console.log('Products fetched successfully:', data)

          if (Array.isArray(data.products)) {
            clearTimeout(this.loadingTimeout)
            this.loading = false
            this.totalItems = data.total || 0
            this.currentPage = data.currentPage || page
            this.pageSize = data.pageSize || pageSize
            this.tableData = data.products.map(product => ({
              product: product.name,
              vatNumber: product.vatNumber,
              codeProduct: product.product_code,
              categorie: product.categorie,
              price: product.price && !isNaN(product.price) ? `${parseInt(product.price).toFixed(2)} ${product.currency}` : 'N/A',
              um: product.um,
              currency: product.currency,
              id: product._id,
              hasReteta: !!(product.reteta && Object.keys(product.reteta).length > 0),
              validity: product.validity
            }))

            this.paginationKey++
          } else {
            console.error('Invalid data format:', data)
          }
        } catch (error) {
          console.error('Error fetching products:', error)

          swal({
            title: 'Error',
            text: 'There was an error fetching products.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        } finally {
          this.loadingProducts = false
        }
      },
      resetFields () {
        this.productName = ''
        this.productDescription = ''
        this.codeProduct = ''
        this.price = ''
        this.currency = 'RON'
        this.um = 'BUC'
      },
      openAddProductModal () {
        this.$modal.show('addProductModal')
      },
      closeModal () {
        this.$modal.hide('addProductModal')
      }
    }
  }
</script>

<style scoped>
.action-buttons {
display: flex;
justify-content: space-between;
align-items: center; /* Aliniază butoanele pe axa verticală */
margin-bottom: 15px;
}
.el-pagination {
  text-align: center !important;
}
.left-buttons {
  display: flex;
  align-items: center;
  gap: 5px;
}

.left-buttons el-button {
margin-right: 10px; /* Spațiere între butoane */
}
.categorie-label {
  background-color: #007bff;
  color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
  margin-right: 6px;
  display: inline-block;
}
.categorie-label.unallocated {
  background-color: gray;
}
.marfa {
  background-color: orange;
}
.semifabricate {
  background-color: #219653;
}
.materii-prime {
  background-color: #2f80ed;
}
.produs-finit {
  background-color: #674BD2;
}
.reteta-label {
  display: inline-block;
  font-style: italic;
  background-color: black;
  color: white;
  padding: 0px 7px;
  border-radius: 12px;
}
.v-select-wrapper {
  position: relative;
}
.v-select-loader {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  border: 3px solid #e0e0e0;     /* mai deschis */
  border-top: 3px solid #007bff;  /* mai contrastant */
  border-radius: 50%;
  width: 24px;                    /* mai mare */
  height: 24px;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.reteta {
  color: white; /* Text alb */
  background-color: purple; /* Fundal mov */
  padding: 2px 8px; /* Margini pentru a face eticheta mai frumoasă */
  border-radius: 4px; /* Colțuri rotunjite */
}
.right-button {
margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
  margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
  margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px;
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoarea săgeții */
}

.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata albă la hover */
}

/* Dropdown menu */
.custom-dropdown-menu {
  min-width: 180px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Nomenclator/NomenclatorProducts.vue